export default {
	"foresite": {
		"addSize": "e添加站点"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/foresite/foresite.js